import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { DEPRECATED_backwardsCompatibleValues } from "@faire/web--source/common/localization/localize";
import { useLocalization } from "@faire/web--source/common/localization/useLocalization";
import { logError } from "@faire/web--source/common/logging";
import { Button } from "@faire/web--source/slate/Button";
import { Checkbox } from "@faire/web--source/slate/Checkbox";
import { Input } from "@faire/web--source/slate/Input";
import { TextArea } from "@faire/web--source/slate/Input/TextArea";
import { Column, Flex, Grid } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { observer } from "mobx-react";
import React from "react";
import styled from "styled-components";
import { blogPage } from "@faire/retailer-visitor-shared/paths/index";
import { MakerSignUpMobileWrapper } from "@faire/retailer/views/apply/MakerApplication/MakerSignUp/MakerSignUpMobileWrapper";
import { MakerSignUpWrapper } from "@faire/retailer/views/apply/MakerApplication/MakerSignUp/MakerSignUpWrapper";
import { BRAND_VALUES } from "./consts";
import { useMakerSignUpAdditionalQuestions } from "./useMakerSignUpAdditionalQuestions";
var MakerSignUpAdditionalQuestionsBase = function(param) {
    var brandLeadToken = param.brandLeadToken;
    var _useLocalization = useLocalization(), locale = _useLocalization.intl.locale;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var viewport = useViewport();
    var _useMakerSignUpAdditionalQuestions = useMakerSignUpAdditionalQuestions(brandLeadToken), handleYearEstablishedChanged = _useMakerSignUpAdditionalQuestions.handleYearEstablishedChanged, handleInstagramHandleChanged = _useMakerSignUpAdditionalQuestions.handleInstagramHandleChanged, isFaireValueSelected = _useMakerSignUpAdditionalQuestions.isFaireValueSelected, onChangeFaireValue = _useMakerSignUpAdditionalQuestions.onChangeFaireValue, additionalNotes = _useMakerSignUpAdditionalQuestions.additionalNotes, setAdditionalNotes = _useMakerSignUpAdditionalQuestions.setAdditionalNotes, errors = _useMakerSignUpAdditionalQuestions.errors, onSave = _useMakerSignUpAdditionalQuestions.onSave, formSubmitted = _useMakerSignUpAdditionalQuestions.formSubmitted, isPostingAdditionalInfo = _useMakerSignUpAdditionalQuestions.isPostingAdditionalInfo;
    var renderFormSubmittedContent = function() {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "displayMSerifRegular",
                            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                id: "fIVbTs",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Thanks!"
                                    }
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx(Spacer, {
                            height: "3x"
                        }),
                        /*#__PURE__*/ _jsx(Typography, {
                            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                id: "oNCE1c",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Your responses will be reviewed by someone on the Faire team."
                                    },
                                    {
                                        type: 1,
                                        value: "lineBreak"
                                    },
                                    {
                                        type: 1,
                                        value: "lineBreak"
                                    },
                                    {
                                        type: 0,
                                        value: "In the meantime, if you'd like to learn a little bit more about how brands use Faire for their wholesale business, you can visit our blog."
                                    }
                                ],
                                values: DEPRECATED_backwardsCompatibleValues({
                                    lineBreak: /*#__PURE__*/ _jsx("br", {})
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsx(Spacer, {
                            height: "3x"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(Button, {
                    variant: "primary",
                    linkTo: "".concat(blogPage(locale), "/thestudio/"),
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "3+QF6y",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Go to Faire Blog"
                            }
                        ]
                    })
                })
            ]
        });
    };
    if (!brandLeadToken) {
        logError("Missing brand lead token");
    }
    if (formSubmitted) {
        if (viewport.isMobile) {
            return /*#__PURE__*/ _jsx(MakerSignUpMobileWrapper, {
                children: /*#__PURE__*/ _jsx(ThankYouPageWrapper, {
                    children: renderFormSubmittedContent()
                })
            });
        }
        return /*#__PURE__*/ _jsx(MakerSignUpWrapper, {
            children: /*#__PURE__*/ _jsx(ThankYouPageWrapper, {
                children: renderFormSubmittedContent()
            })
        });
    }
    return /*#__PURE__*/ _jsxs(MakerSignUpWrapper, {
        children: [
            /*#__PURE__*/ _jsx(FormHeaderContentWrapper, {
                children: /*#__PURE__*/ _jsx(Typography, {
                    variant: "displaySSerifRegular",
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "O2KQcg",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Tell us more about your brand"
                            }
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsxs(FormContentWrapper, {
                children: [
                    /*#__PURE__*/ _jsx(Spacer, {
                        size: "3x"
                    }),
                    /*#__PURE__*/ _jsxs(DesktopRow, {
                        children: [
                            /*#__PURE__*/ _jsx(Input, {
                                label: strictLocalize({
                                    id: "LALY3i",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "Year Established"
                                        }
                                    ]
                                }),
                                onChange: handleYearEstablishedChanged,
                                error: errors.yearEstablished
                            }),
                            /*#__PURE__*/ _jsx(Spacer, {
                                size: "2x"
                            }),
                            /*#__PURE__*/ _jsx(Input, {
                                prefixNode: "@",
                                label: strictLocalize({
                                    id: "zT5BDR",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "Instagram Handle"
                                        }
                                    ]
                                }),
                                onChange: handleInstagramHandleChanged,
                                error: errors.instagramHandle
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        size: "3x"
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraphSansMedium",
                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "SoMgRf",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Which Faire values resonate most with your brand?"
                                }
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        size: "2x"
                    }),
                    /*#__PURE__*/ _jsx(Grid, {
                        columns: 2,
                        gap: 16,
                        children: BRAND_VALUES(strictLocalize).map(function(value, index) {
                            return /*#__PURE__*/ _jsx(Checkbox, {
                                label: value.label,
                                checked: isFaireValueSelected(value),
                                onChange: function() {
                                    return onChangeFaireValue(value);
                                }
                            }, index);
                        })
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        size: "3x"
                    }),
                    /*#__PURE__*/ _jsx(TextArea, {
                        value: additionalNotes,
                        label: strictLocalize({
                            id: "/pz28p",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Anything else to share?"
                                }
                            ]
                        }),
                        onChange: function(e) {
                            return setAdditionalNotes(e.target.value);
                        },
                        style: {
                            height: "100px"
                        },
                        maxLength: 1000
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        size: "3x"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(StickyContent, {
                children: [
                    /*#__PURE__*/ _jsx(CTAButton, {
                        onClick: onSave,
                        loading: isPostingAdditionalInfo,
                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "YY0zB0",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Submit"
                                }
                            ]
                        })
                    }),
                    errors.submission ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(Spacer, {
                                height: "1x"
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                color: Core.text.critical,
                                children: errors.submission
                            })
                        ]
                    }) : null
                ]
            })
        ]
    });
};
export var MakerSignUpAdditionalQuestions = observer(MakerSignUpAdditionalQuestionsBase);
var ThankYouPageWrapper = styled(Column).attrs({
    justify: "space-between"
}).withConfig({
    componentId: "sc-3a11fa6b-0"
})([
    "",
    "{min-height:500px;}",
    "{padding:",
    ";}"
], responsiveMediaQueries.tabletAndAbove, responsiveMediaQueries.mobile, getSpacing("3x"));
var StickyContent = styled(Column).withConfig({
    componentId: "sc-3a11fa6b-1"
})([
    "padding:",
    ";",
    "{padding:",
    ";background-color:",
    ";width:100%;position:sticky;z-index:100;top:0;bottom:0;}"
], getSpacing(0, 0, "3x"), responsiveMediaQueries.mobile, getSpacing("2x"), Core.surface.inverse);
var CTAButton = styled(Button).attrs({
    variant: "primary"
}).withConfig({
    componentId: "sc-3a11fa6b-2"
})([
    "width:fit-content;min-width:250px;",
    "{width:100%;}"
], responsiveMediaQueries.mobile);
var FormContentWrapper = styled(Column).withConfig({
    componentId: "sc-3a11fa6b-3"
})([
    "width:100%;",
    "{background-color:",
    ";padding:0 ",
    ";}"
], responsiveMediaQueries.mobile, Core.surface.inverse, getSpacing("3x"));
var FormHeaderContentWrapper = styled(Column).withConfig({
    componentId: "sc-3a11fa6b-4"
})([
    "",
    "{padding:",
    ";}"
], responsiveMediaQueries.mobile, getSpacing("3x"));
var DesktopRow = styled(Flex).attrs({
    direction: {
        mobileAndAbove: "column",
        tabletAndAbove: "row"
    }
}).withConfig({
    componentId: "sc-3a11fa6b-5"
})([
    ""
]);
